<template>
  <v-container fluid class="privacy-page">
    <v-row justify="center">
      <v-col cols="12" md="10" lg="8" xl="7">
        <v-card class="privacy-card" elevation="3">
          <!-- Encabezado -->
          <div class="privacy-header">
            <div class="text-overline mb-1">
              MEDICOVER
            </div>

            <h1 class="privacy-title">
              Aviso de Privacidad
            </h1>

            <p class="privacy-update mb-0">
              Última actualización: 18 de junio de 2026
            </p>
          </div>

          <v-card-text class="privacy-content pa-5 pa-md-8">
            <p>
              En cumplimiento al deber de resguardo de información y de datos
              personales y con fundamento en los dispuesto por los artículos 3
              fracción I, 8, 12, 15, 16 y demás relativos de la Ley Federal de
              Protección de Datos Personales en Posesión de Particulares,
              Armando Ricavar Cisneros, con nombre comercial Armando Ricavar
              Cisneros, pone a su disposición el presente Aviso de Privacidad.
            </p>

            <section class="privacy-section">
              <h2 class="section-title">
                Identidad y domicilio del responsable de la protección de datos
                personales
              </h2>

              <p>
                Armando Ricavar Cisneros, con nombre comercial Armando Ricavar
                Cisneros, ubicado en Nicolas Zapata #710, Col. Arboleda de
                Tequisquiapan, C.P. 78235, es la persona responsable del uso y
                protección de sus datos personales.
              </p>
            </section>

            <v-divider class="section-divider" />

            <section class="privacy-section">
              <h2 class="section-title">
                Datos personales utilizados
              </h2>

              <p>
                Para llevar a cabo las finalidades descritas en este Aviso de
                Privacidad, haremos uso de los siguientes datos personales:
              </p>

              <ul class="privacy-list">
                <li>Datos de contacto</li>
                <li>Datos de identificación</li>
                <li>Datos sobre características físicas</li>
                <li>Datos de facturación</li>
                <li>Datos laborales</li>
                <li>Datos académicos</li>
                <li>Datos patrimoniales o financieros</li>
                <li>Telefono movil</li>
              </ul>

              <v-alert
                text
                type="info"
                border="left"
                class="mt-5 mb-0"
              >
                Además de los datos personales mencionados, utilizaremos los
                siguientes datos sensibles, que requieren de especial
                protección:

                <ul class="privacy-list mb-0 mt-2">
                  <li>Datos de salud</li>
                </ul>
              </v-alert>
            </section>

            <v-divider class="section-divider" />

            <section class="privacy-section">
              <h2 class="section-title">
                Cookies, web beacons y tecnologías similares
              </h2>

              <p>
                Utilizamos cookies, web beacons y/o tecnologías similares para
                mejorar su experiencia en nuestro sitio web. Estas herramientas
                recopilan información como su dirección IP, tipo de navegador,
                páginas visitadas y la duración de su visita.
              </p>

              <p>
                Esta información se puede utilizar para analizar tendencias,
                administrar el sitio y mejorar nuestros servicios.
              </p>

              <p>
                Puede deshabilitar estas tecnologías en la configuración de su
                navegador, pero tenga en cuenta que esto podría afectar la
                funcionalidad del sitio.
              </p>
            </section>

            <v-divider class="section-divider" />

            <section class="privacy-section">
              <h2 class="section-title">
                Medidas de seguridad y tiempo de conservación
              </h2>

              <p>
                Hemos implementado medidas de seguridad técnicas,
                administrativas y físicas para resguardar la seguridad de sus
                datos personales, cumpliendo con los estándares legales.
              </p>

              <p>
                La retención de sus datos se extenderá por un periodo de hasta
                99 años, en consonancia con los propósitos expuestos en este
                aviso y los plazos legales correspondientes.
              </p>
            </section>

            <v-divider class="section-divider" />

            <section class="privacy-section">
              <h2 class="section-title">
                Finalidades del tratamiento de datos personales
              </h2>

              <p>
                Utilizaremos los datos recabados para las siguientes finalidades,
                que son necesarias para el servicio solicitado:
              </p>

              <ul class="privacy-list">
                <li>Finalidad de contacto, aclaraciones y comunicación</li>
                <li>Finalidad de facturación y cobro</li>
                <li>Finalidad de envío y entrega de productos y servicios</li>
                <li>Finalidad de establecer una relación comercial</li>
              </ul>

              <p class="mt-5">
                De manera adicional, utilizaremos su información personal para
                las siguientes finalidades, que no son necesarias para el
                servicio solicitado, pero que nos permiten y facilitan brindarle
                una mejor atención:
              </p>

              <ul class="privacy-list">
                <li>Finalidad de enviar información promocional</li>
                <li>Finalidad de realizar encuestas de satisfacción</li>
              </ul>
            </section>

            <v-divider class="section-divider" />

            <section class="privacy-section">
              <h2 class="section-title">
                Transferencias de datos que se efectúen
              </h2>

              <p>
                No compartiremos sus datos personales con terceros, salvo por
                requerimientos legales. Los datos serán utilizados
                exclusivamente para los fines señalados en este Aviso de
                Privacidad.
              </p>
            </section>

            <v-divider class="section-divider" />

            <section class="privacy-section">
              <h2 class="section-title">
                Medios para ejercer los derechos de acceso, rectificación,
                cancelación u oposición
              </h2>

              <p>
                Usted tiene el derecho de conocer los datos personales que
                tenemos sobre usted, así como su utilización y las condiciones
                bajo las cuales son tratados (Derecho de Acceso).
              </p>

              <p>
                De igual manera, le asiste el derecho de solicitar la corrección
                de su información personal en caso de estar desactualizada,
                inexacta o incompleta (Derecho de Rectificación); requerir la
                eliminación de sus datos de nuestros registros o bases de datos
                si considera que su uso no concuerda con los principios, deberes
                y obligaciones establecidos por la normativa (Derecho de
                Cancelación); así como oponerse al tratamiento de sus datos
                personales para fines específicos (Derecho de Oposición).
              </p>

              <p>
                Estos derechos son conocidos como derechos ARCO.
              </p>

              <p>
                A continuación, proporcionamos los datos de contacto de la
                persona o departamento encargado de gestionar las solicitudes
                relacionadas con los derechos ARCO:
              </p>

              <v-card outlined class="contact-card pa-4 pa-md-5">
                <div class="contact-row">
                  <strong>Nombre:</strong>
                  <span>Atencion a clientes</span>
                </div>

                <div class="contact-row">
                  <strong>Domicilio:</strong>
                  <span>
                    Nicolas Zapata # 710, Col. Arboleda de Tequisquiapan,
                    c.P. 78235, San Luis Potosi, S.L.P.
                  </span>
                </div>

                <div class="contact-row">
                  <strong>Teléfono:</strong>

                  <a href="tel:4448135480">
                    444 813 5480 ext. 113
                  </a>
                </div>

                <div class="contact-row">
                  <strong>Correo electrónico:</strong>

                  <a href="mailto:atencionclientes@medicover.com.mx">
                    atencionclientes@medicover.com.mx
                  </a>
                </div>
              </v-card>

              <p class="mt-5">
                Si desea ejercer los derechos de acceso, rectificación,
                cancelación u oposición del tratamiento de sus datos personales
                o limitar su divulgación, puede presentar la solicitud
                respectiva a través del siguiente correo electrónico:
              </p>

              <p>
                <a
                  class="privacy-email"
                  href="mailto:atencionclientes@medicover.com.mx"
                >
                  atencionclientes@medicover.com.mx
                </a>
              </p>

              <p>
                La respuesta a su solicitud será comunicada de la siguiente
                manera:
              </p>

              <p>
                Las respuestas seran enviadas via correo electrónico al buzón
                enviado por el cliente solicitante.
              </p>

              <p>
                El plazo para brindar respuesta a su solicitud será el
                siguiente: 5 dias habiles.
              </p>
            </section>

            <v-divider class="section-divider" />

            <section class="privacy-section">
              <h2 class="section-title">
                Opciones y medios que el responsable ofrezca a los titulares
                para limitar el uso o divulgación de los datos
              </h2>

              <p>
                Si desea revocar el consentimiento otorgado para el tratamiento
                de sus datos personales o limitar su divulgación, puede
                presentar la solicitud respectiva a través del siguiente correo
                electrónico:
              </p>

              <p>
                <a
                  class="privacy-email"
                  href="mailto:atencionclientes@medicover.com.mx"
                >
                  atencionclientes@medicover.com.mx
                </a>
              </p>

              <p>
                La comunicación de la respuesta a la solicitud de revocación o
                limitación de divulgación de sus datos se llevará a cabo de la
                siguiente forma:
              </p>

              <p>
                Las respuestas serán enviadas al correo electrónico
                proporcionado por el solicitante.
              </p>

              <p>
                La respuesta a la solicitud de revocación o limitación de
                divulgación de sus datos se proporcionará en un plazo máximo
                de: 20 dias hábiles.
              </p>
            </section>

            <v-divider class="section-divider" />

            <section class="privacy-section">
              <h2 class="section-title">
                Cambios al aviso de privacidad
              </h2>

              <p>
                El presente aviso de privacidad puede sufrir modificaciones,
                cambios o actualizaciones derivadas de nuevos requerimientos
                legales; de nuestras propias necesidades por los productos o
                servicios que ofrecemos; de nuestras prácticas de privacidad;
                de cambios en nuestro modelo de negocio, o por otras causas, por
                lo cual, nos comprometemos a mantenerlo informado sobre los
                cambios que pueda sufrir el presente aviso de privacidad.
              </p>

              <p>
                Sin embargo, usted puede solicitar información sobre si el
                mismo ha sufrido algún cambio a través del siguiente correo
                electrónico:
              </p>

              <p>
                <a
                  class="privacy-email"
                  href="mailto:atencionclientes@medicover.com.mx"
                >
                  atencionclientes@medicover.com.mx
                </a>
              </p>
            </section>

            <v-alert
              text
              color="primary"
              border="left"
              class="privacy-date mt-7 mb-0"
            >
              <strong>Última actualización:</strong>
              18 de junio de 2026
            </v-alert>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "AvisoPrivacidad",

  metaInfo: {
    title: "Aviso de Privacidad | MEDICOVER",
    meta: [
      {
        name: "description",
        content:
          "Aviso de privacidad y tratamiento de datos personales de MEDICOVER."
      }
    ]
  }
};
</script>

<style scoped>
.privacy-page {
  min-height: 100vh;
  padding-top: 40px;
  padding-bottom: 60px;
  background: #f4f7fa;
}

.privacy-card {
  overflow: hidden;
  border-radius: 14px;
}

.privacy-header {
  padding: 34px 40px;
  color: #ffffff;
  background: linear-gradient(135deg, #6598c1 0%, #487ca5 100%);
}

.privacy-title {
  margin: 0 0 8px;
  font-size: 34px;
  font-weight: 700;
  line-height: 1.2;
}

.privacy-update {
  font-size: 14px;
  opacity: 0.9;
}

.privacy-content {
  color: #394451 !important;
  font-size: 16px;
  line-height: 1.75;
}

.privacy-content p {
  margin-bottom: 16px;
}

.privacy-section {
  scroll-margin-top: 90px;
}

.section-title {
  margin: 0 0 18px;
  color: #3f7199;
  font-size: 21px;
  font-weight: 700;
  line-height: 1.4;
  text-transform: uppercase;
}

.section-divider {
  margin: 32px 0;
}

.privacy-list {
  padding-left: 25px;
  margin-top: 10px;
  margin-bottom: 15px;
}

.privacy-list li {
  padding-left: 5px;
  margin-bottom: 7px;
}

.contact-card {
  border-color: #d8e3ec;
  border-radius: 10px;
  background-color: #f8fafc;
}

.contact-row {
  display: grid;
  grid-template-columns: 170px 1fr;
  column-gap: 16px;
  margin-bottom: 12px;
}

.contact-row:last-child {
  margin-bottom: 0;
}

.contact-row strong {
  color: #3f7199;
}

.contact-row a,
.privacy-email {
  color: #3f7199;
  font-weight: 600;
  text-decoration: none;
  overflow-wrap: anywhere;
}

.contact-row a:hover,
.privacy-email:hover {
  text-decoration: underline;
}

.privacy-date {
  border-radius: 8px;
}

@media (max-width: 600px) {
  .privacy-page {
    padding: 0;
    background: #ffffff;
  }

  .privacy-card {
    border-radius: 0;
    box-shadow: none !important;
  }

  .privacy-header {
    padding: 28px 22px;
  }

  .privacy-title {
    font-size: 27px;
  }

  .privacy-content {
    font-size: 15px;
  }

  .section-title {
    font-size: 18px;
  }

  .section-divider {
    margin: 26px 0;
  }

  .contact-row {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }
}
</style>